// Онлайн тест өгөх (сурагч): танилцуулга → эхлэх → асуулт бүрээр шилжих, хугацаа тоолуур, 5 сек тутам автоматаар хадгалах,
// илгээхийн өмнө баталгаажуулах; хугацаа дуусвал автоматаар илгээнэ (сервер ч мөн хянана). Илгээсний дараа зөвшөөрсөн бол үр дүн.
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Input, Modal, Spin } from "antd";
import { FiArrowLeft, FiCheck, FiClock, FiX } from "react-icons/fi";
import { instance } from "utils/axios";
import { fmtClock, fmtWhen, isAnswered, scoreText, TYPE_HINT, wordCount } from "./common";
import PdfPages from "./PdfPages";

const AUTOSAVE_MS = 5000;
const req = (method, url, data) => instance({ method, url, data, silent: true }).then((r) => r.data);

// Нэг асуултын хариулах хэсэг
// Файл сонгох / микрофоны зөвшөөрөл асуух үед цонх "blur" болдог — үүнийг шалгалтаас гарсанд тооцохгүй
let lockPausedUntil = 0;
const pauseLock = (ms = 120000) => { lockPausedUntil = Date.now() + ms; };
const resumeLock = () => { lockPausedUntil = 0; };
const lockPaused = () => Date.now() < lockPausedUntil;

const uploadAnswer = (examId, qid, file, name) => {
  const fd = new FormData();
  fd.append("file", file, name || file.name);
  return instance({ method: "post", url: `/student/exams/${examId}/answers/${qid}/file`, data: fd, silent: true }).then((r) => r.data);
};

function VoiceAnswer({ examId, q, value, onChange }) {
  const [rec, setRec] = useState(null);
  const [sec, setSec] = useState(0);
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const chunks = useRef([]);
  useEffect(() => { if (!rec) return undefined; const t = setInterval(() => setSec((x) => x + 1), 1000); return () => clearInterval(t); }, [rec]);
  const start = async () => {
    setErr(null);
    pauseLock(30000);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      resumeLock();
      const mr = new MediaRecorder(stream);
      chunks.current = [];
      mr.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        const type = mr.mimeType || "audio/webm";
        const blob = new Blob(chunks.current, { type });
        setUrl(URL.createObjectURL(blob));
        setBusy(true);
        try { const r = await uploadAnswer(examId, q.id, blob, `voice-${q.id}.${type.includes("mp4") ? "m4a" : type.includes("ogg") ? "ogg" : "webm"}`); onChange({ fileName: r.fileName }); }
        catch (e) { setErr(e?.response?.data?.error || "Илгээж чадсангүй — дахин бичнэ үү"); }
        finally { setBusy(false); }
      };
      mr.start();
      setSec(0);
      setRec(mr);
    } catch (e) { resumeLock(); setErr("Микрофон ашиглах зөвшөөрөл өгнө үү"); }
  };
  const stop = () => { rec?.stop(); setRec(null); };
  // 5 минутаас урт бол автоматаар зогсооно
  useEffect(() => { if (rec && sec >= 300) stop(); }, [sec]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-3">
        {rec ? <Button danger size="large" onClick={stop}>■ Зогсоох · {fmtClock(sec)}</Button>
          : <Button type="primary" size="large" onClick={start} loading={busy}>{value?.fileName ? "● Дахин бичих" : "● Бичлэг эхлүүлэх"}</Button>}
        {value?.fileName && !rec && !busy && <span className="text-sm text-emerald-700 font-semibold">✓ Бичлэг илгээгдсэн</span>}
      </div>
      {url && !rec && <audio src={url} controls className="w-full max-w-md" />}
      {err && <span className="text-sm text-red-600">{err}</span>}
      <span className="text-xs text-gray-400">Дээд тал нь 5 минут. Дахин бичвэл өмнөхийг солино.</span>
    </div>
  );
}

function FileAnswer({ examId, q, value, onChange }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const pick = () => { pauseLock(); ref.current?.click(); };
  const onFile = async (e) => {
    resumeLock();
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setErr(null); setBusy(true);
    try { const r = await uploadAnswer(examId, q.id, f); onChange({ fileName: r.fileName }); }
    catch (x) { setErr(x?.response?.data?.error || "Илгээж чадсангүй"); }
    finally { setBusy(false); }
  };
  useEffect(() => { const back = () => setTimeout(resumeLock, 800); window.addEventListener("focus", back); return () => window.removeEventListener("focus", back); }, []);
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-3">
        <Button size="large" onClick={pick} loading={busy}>{value?.fileName ? "Өөр файл сонгох" : "Зураг / файл сонгох"}</Button>
        {value?.fileName && <span className="text-sm text-emerald-700 font-semibold truncate max-w-[60%]">✓ {value.fileName}</span>}
      </div>
      <input ref={ref} type="file" accept="image/*,.pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx" capture={undefined} className="hidden" onChange={onFile} />
      {err && <span className="text-sm text-red-600">{err}</span>}
      <span className="text-xs text-gray-400">Утаснаас бодолтынхоо зургийг авч оруулж болно. 25MB хүртэл.</span>
    </div>
  );
}

function AnswerInput({ q, value, onChange, examId }) {
  const a = value || {};
  if (q.type === "voice") return <VoiceAnswer examId={examId} q={q} value={a} onChange={onChange} />;
  if (q.type === "file") return <FileAnswer examId={examId} q={q} value={a} onChange={onChange} />;
  if (q.type === "single" || q.type === "multiple") {
    const sel = a.optionIds || [];
    const toggle = (id) => {
      if (q.type === "single") onChange({ optionIds: sel[0] === id ? [] : [id] });
      else onChange({ optionIds: sel.includes(id) ? sel.filter((x) => x !== id) : [...sel, id] });
    };
    return (
      <div className="flex flex-col gap-2" role={q.type === "single" ? "radiogroup" : "group"}>
        {q.options.map((o, i) => {
          const on = sel.includes(o.id);
          return (
            <button key={o.id} type="button" role={q.type === "single" ? "radio" : "checkbox"} aria-checked={on} onClick={() => toggle(o.id)}
              className={`flex items-center gap-3 text-left rounded-xl border px-3.5 py-3 transition-colors ${on ? "border-primary bg-primary/5" : "border-gray-200 bg-white hover:border-gray-300"}`}>
              <span className={`h-6 w-6 shrink-0 flex items-center justify-center border-2 ${q.type === "single" ? "rounded-full" : "rounded-md"} ${on ? "border-primary bg-primary text-white" : "border-gray-300"}`}>
                {on && <FiCheck size={14} />}
              </span>
              <span className="text-xs font-semibold text-gray-400">{String.fromCharCode(65 + i)}</span>
              <span className="flex-1 text-[15px] text-gray-900 whitespace-pre-wrap">{o.text}</span>
            </button>
          );
        })}
      </div>
    );
  }
  if (q.type === "long") {
    const n = wordCount(a.text);
    return (
      <div className="flex flex-col gap-1">
        <Input.TextArea value={a.text || ""} onChange={(e) => onChange({ text: e.target.value })} autoSize={{ minRows: 6, maxRows: 20 }} maxLength={20000} placeholder="Хариултаа бичнэ үү" aria-label="Хариулт" />
        <span className={`text-xs ${q.minWords && n < q.minWords ? "text-amber-700" : "text-gray-500"}`}>{n}{q.minWords ? ` / ${q.minWords}` : ""} үг{q.minWords && n < q.minWords ? ` — дор хаяж ${q.minWords} үг бичнэ` : ""}</span>
      </div>
    );
  }
  return (
    <Input value={a.text || ""} onChange={(e) => onChange({ text: e.target.value })} size="large" maxLength={500} aria-label="Хариулт"
      inputMode={q.type === "number" ? "decimal" : undefined} placeholder={q.type === "number" ? "Тоо" : "Хариулт"} style={{ maxWidth: q.type === "number" ? 220 : 480 }} />
  );
}

// Илгээсний дараах үр дүн (оноо, асуулт бүрийн оноо; хаагдсаны дараа зөв хариулт)
function ResultView({ exam, attempt, result }) {
  return (
    <div className="flex flex-col gap-3">
      <section className="pcard pcard-pad flex flex-col items-center text-center gap-1">
        <span className="h-12 w-12 rounded-full bg-emerald-50 text-emerald-700 flex items-center justify-center"><FiCheck size={24} /></span>
        <div className="text-base font-bold mt-1">Тест илгээгдсэн</div>
        <div className="text-xs text-gray-500">{fmtWhen(attempt.submittedAt)}</div>
        {result ? (
          <>
            <div className="text-3xl font-bold text-primary mt-2">{scoreText(result)}</div>
            {result.pending && <div className="text-xs text-gray-500">* Зарим хариултыг багш дүгнээгүй байна</div>}
          </>
        ) : (
          <div className="text-sm text-gray-500 mt-2">Оноо багш нээсний дараа харагдана</div>
        )}
      </section>
      {result && result.questions.map((q, i) => {
        const full = q.earned != null && q.earned >= q.points;
        return (
          <section key={q.id} className="pcard p-3.5 flex flex-col gap-2">
            <div className="flex gap-2 items-start">
              <span className="font-bold text-primary">{i + 1}.</span>
              <div className="flex-1 text-sm whitespace-pre-wrap">{q.text}</div>
              <span className={`text-sm font-semibold shrink-0 ${q.earned == null ? "text-gray-400" : full ? "text-emerald-700" : q.earned > 0 ? "text-amber-700" : "text-red-600"}`}>
                {q.earned == null ? "—" : q.earned} / {q.points}
              </span>
            </div>
            {q.imageUrl && <img src={q.imageUrl} alt="" className="max-h-48 rounded-lg border border-gray-100 self-start" />}
            {q.options.length > 0 ? (
              <ul className="list-none p-0 m-0 flex flex-col gap-1">
                {q.options.map((o) => {
                  const mine = q.answer.optionIds.includes(o.id);
                  const known = o.isCorrect !== undefined;
                  return (
                    <li key={o.id} className={`flex items-center gap-2 rounded-lg px-2.5 py-1.5 text-sm border ${mine ? (known ? (o.isCorrect ? "bg-emerald-50 border-emerald-200" : "bg-red-50 border-red-200") : "bg-primary/5 border-primary/30") : known && o.isCorrect ? "border-emerald-200 border-dashed" : "border-gray-100"}`}>
                      <span className="w-4">{mine ? (known && !o.isCorrect ? <FiX className="text-red-600" /> : <FiCheck className={known ? "text-emerald-700" : "text-primary"} />) : null}</span>
                      <span className="flex-1">{o.text}</span>
                      {known && o.isCorrect && <span className="text-[11px] font-semibold text-emerald-700">зөв</span>}
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="text-sm">
                <div className={`rounded-lg border px-3 py-2 whitespace-pre-wrap ${q.answer.text ? "bg-gray-50 border-gray-100" : "border-dashed border-gray-200 text-gray-400"}`}>{q.answer.text || "Хариулаагүй"}</div>
                {result.keys && q.answerText && <div className="text-xs text-emerald-700 mt-1">Зөв хариулт: <b>{q.answerText}</b>{q.tolerance ? ` ± ${q.tolerance}` : ""}</div>}
              </div>
            )}
          </section>
        );
      })}
      {result && !result.keys && <div className="text-xs text-center text-gray-400">Зөв хариултууд тест хаагдсаны дараа харагдана</div>}
      <Link to="/exams" className="text-center text-sm font-semibold text-primary">Шалгалтууд руу буцах</Link>
    </div>
  );
}

// ── Шалгалтын үеийн түгжээ: бүтэн дэлгэц, гарвал/өөр цонх руу шилжвэл тестийг нууж буцахыг шаардана ──
// Хөтөч бүтэн дэлгэцээс гарахыг (Esc) бүрэн хориглох боломжгүй — тиймээс гарсан тоог тоолж, тест нуугдана.
const fsSupported = () => !!(document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen);
// → Promise<boolean>: бүтэн дэлгэц болсон эсэх (хөтөч татгалзаж болно)
const enterFs = () => { const el = document.documentElement; try { const r = (el.requestFullscreen || el.webkitRequestFullscreen)?.call(el); return Promise.resolve(r).then(() => isFs(), () => false); } catch (e) { return Promise.resolve(false); } };
const exitFs = () => { try { if (document.fullscreenElement || document.webkitFullscreenElement) (document.exitFullscreen || document.webkitExitFullscreen)?.call(document)?.catch?.(() => {}); } catch (e) { /* noop */ } };
const isFs = () => !!(document.fullscreenElement || document.webkitFullscreenElement);

function useExamLock(active, examId) {
  const KEY = `examLeaves:${examId}`;
  const [leaves, setLeaves] = useState(() => { try { return Number(localStorage.getItem(KEY)) || 0; } catch (e) { return 0; } });
  const [away, setAway] = useState(false);
  const [fs, setFs] = useState(isFs());
  // Хөтөч бүтэн дэлгэцийг зөвшөөрөхгүй бол (iframe, бодлого г.м.) сурагчийг түгжихгүй — зөвхөн цонхноос гарсныг тоолно
  const [fsBlocked, setFsBlocked] = useState(false);
  useEffect(() => {
    if (!active) { exitFs(); return undefined; }
    const bump = () => setLeaves((n) => { const v = n + 1; try { localStorage.setItem(KEY, String(v)); } catch (e) { /* noop */ } return v; });
    const onFs = () => { const on = isFs(); setFs(on); if (!on) { bump(); setAway(true); } };
    // Нэг гаралтыг нэг л удаа тоолно (blur + visibilitychange зэрэг ирж болно)
    let out = false;
    const leave = () => { if (out || lockPaused()) return; out = true; bump(); setAway(true); };
    const onVis = () => { if (document.visibilityState === "hidden") leave(); };
    // PDF (iframe) дотор дарахад цонх blur болдог ч фокус манай хуудсанд хэвээр (document.hasFocus) — гарсанд тооцохгүй
    const onBlur = () => setTimeout(() => { if (document.visibilityState === "visible" && !document.hasFocus()) leave(); }, 0);
    const onFocus = () => { out = false; };
    // PDF дотор фокустай байхад өөр цонх руу шилжихэд blur дахин ирэхгүй — секунд тутам шалгана
    const poll = setInterval(() => { if (document.visibilityState === "visible" && !document.hasFocus()) leave(); else if (document.hasFocus()) out = false; }, 1000);
    const onUnload = (e) => { e.preventDefault(); e.returnValue = ""; };
    document.addEventListener("fullscreenchange", onFs); document.addEventListener("webkitfullscreenchange", onFs);
    document.addEventListener("visibilitychange", onVis); window.addEventListener("blur", onBlur); window.addEventListener("focus", onFocus); window.addEventListener("beforeunload", onUnload);
    return () => {
      clearInterval(poll); window.removeEventListener("focus", onFocus);
      document.removeEventListener("fullscreenchange", onFs); document.removeEventListener("webkitfullscreenchange", onFs);
      document.removeEventListener("visibilitychange", onVis); window.removeEventListener("blur", onBlur); window.removeEventListener("beforeunload", onUnload);
    };
  }, [active]); // eslint-disable-line react-hooks/exhaustive-deps
  const resume = () => { setAway(false); if (fsSupported()) enterFs().then((ok) => { setFs(ok); if (!ok) setFsBlocked(true); }); };
  // Бүтэн дэлгэцийг дэмждэг (мөн зөвшөөрсөн) төхөөрөмж дээр бүтэн дэлгэцгүй үед, эсвэл өөр цонх руу гарсны дараа тест нуугдана
  const locked = active && (away || (fsSupported() && !fsBlocked && !fs));
  return { locked, leaves, resume };
}

function LockScreen({ leaves, onResume }) {
  return (
    <div role="alertdialog" aria-modal="true" aria-labelledby="lock-title" className="fixed inset-0 z-[1000] bg-white flex flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="w-14 h-14 rounded-full bg-primary/10 text-primary flex items-center justify-center"><FiClock size={28} /></div>
      <h2 id="lock-title" className="text-xl font-extrabold text-gray-900 m-0">Тест үргэлжилж байна</h2>
      <p className="text-sm text-gray-600 m-0 max-w-sm">Шалгалтын үеэр бүтэн дэлгэцээс гарах, өөр цонх руу шилжихийг хориглоно. Хугацаа тоологдсоор байна.</p>
      {leaves > 0 && <p className="text-sm font-semibold text-red-600 m-0">Та {leaves} удаа гарсан.</p>}
      <Button type="primary" size="large" onClick={onResume}>Бүтэн дэлгэц рүү буцах</Button>
    </div>
  );
}

// ── Хариултын хуудас: зүүн талд шалгалтын хуудас (PDF/зураг), баруун талд дугаар бүрийн сонголт ──
function FileViewer({ examId, files }) {
  const [cur, setCur] = useState(files[0]?.id);
  const [urls, setUrls] = useState({});
  useEffect(() => {
    let alive = true;
    const made = [];
    files.forEach((f) => instance({ method: "get", url: `/student/exams/${examId}/files/${f.id}`, responseType: "blob", silent: true })
      .then((r) => { if (!alive) return; const u = URL.createObjectURL(r.data); made.push(u); setUrls((x) => ({ ...x, [f.id]: u })); }).catch(() => {}));
    return () => { alive = false; made.forEach((u) => URL.revokeObjectURL(u)); };
  }, [examId, files]);
  const f = files.find((x) => x.id === cur) || files[0];
  return (
    <div className="flex flex-col gap-2 h-full min-h-0">
      {files.length > 1 && (
        <div className="flex gap-1.5 flex-wrap">{files.map((x, i) => <button key={x.id} type="button" onClick={() => setCur(x.id)} className={`px-3 h-8 rounded-lg text-sm border ${x.id === f.id ? "border-primary bg-primary/10 text-primary font-semibold" : "border-gray-200 bg-white"}`}>{i + 1}-р хуудас</button>)}</div>
      )}
      <div className={`flex-1 ${f.kind === "pdf" ? "min-h-[40vh]" : ""} max-h-[60vh] md:max-h-none md:min-h-0 rounded-xl border border-gray-200 bg-white overflow-auto`}>
        {!urls[f.id] ? <div className="h-full flex items-center justify-center py-16"><Spin /></div>
          : f.kind === "pdf" ? <PdfPages url={urls[f.id]} name={f.name} />
            : <img src={urls[f.id]} alt={f.name} className="w-full h-auto block" />}
      </div>
    </div>
  );
}

function AnswerSheet({ questions, answers, onAnswer, examId }) {
  return (
    <ol className="list-none m-0 p-0 flex flex-col gap-2.5">
      {questions.map((q) => {
        const sel = answers[q.id]?.optionIds || [];
        const choice = q.type === "single" || q.type === "multiple";
        const pick = (oid) => onAnswer(q.id, { optionIds: q.type === "multiple" ? (sel.includes(oid) ? sel.filter((x) => x !== oid) : [...sel, oid]) : [oid] });
        return (
          <li key={q.id} className={`flex gap-2 ${choice ? "items-center" : "items-start flex-col"}`}>
            <span className="flex items-center gap-2">
              <span className="w-8 text-right text-sm font-bold tabular-nums text-gray-700">{q.text}.</span>
              {!choice && <span className="text-xs text-gray-500">{TYPE_HINT[q.type]} · {q.points} оноо</span>}
            </span>
            {choice ? (
              <div role={q.type === "single" ? "radiogroup" : "group"} aria-label={`${q.text}-р асуулт`} className="flex gap-1.5 flex-wrap">
                {q.options.map((o) => (
                  <button key={o.id} type="button" role={q.type === "single" ? "radio" : "checkbox"} aria-checked={sel.includes(o.id)} onClick={() => pick(o.id)}
                    className={`w-9 h-9 ${q.type === "multiple" ? "rounded-lg" : "rounded-full"} text-sm font-bold border transition ${sel.includes(o.id) ? "bg-primary border-primary text-white" : "bg-white border-gray-300 text-gray-700 hover:border-primary"}`}>{o.text}</button>
                ))}
              </div>
            ) : (
              <div className="w-full pl-10"><AnswerInput q={q} examId={examId} value={answers[q.id]} onChange={(p) => onAnswer(q.id, p)} /></div>
            )}
          </li>
        );
      })}
    </ol>
  );
}

export default function ExamTake() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [answers, setAnswers] = useState({});
  const [idx, setIdx] = useState(0);
  const [saveState, setSaveState] = useState("saved"); // saved | dirty | saving | error
  const [busy, setBusy] = useState(false);
  const [, setTick] = useState(0);
  const offset = useRef(0); // серверийн цаг − төхөөрөмжийн цаг
  const dirty = useRef(new Set());
  const answersRef = useRef({});
  const saving = useRef(false);
  const submitting = useRef(false);

  const apply = useCallback((d) => {
    offset.current = new Date(d.now).getTime() - Date.now();
    setData(d);
    if (d.answers) {
      // Хадгалаагүй (dirty) хариултыг дарж бичихгүй
      const merged = { ...d.answers };
      dirty.current.forEach((qid) => { if (answersRef.current[qid]) merged[qid] = answersRef.current[qid]; });
      answersRef.current = merged;
      setAnswers(merged);
    }
  }, []);

  const load = useCallback(() => req("get", `/student/exams/${id}`).then(apply).catch((e) => setError(e?.response?.data?.error || "Тест олдсонгүй")), [id, apply]);
  useEffect(() => { load(); }, [load]);

  const inProgress = data?.attempt?.status === "in_progress";
  const questions = data?.questions || [];
  const lock = useExamLock(inProgress, id);

  const setAnswer = (qid, patch) => {
    const next = { ...answersRef.current, [qid]: { ...(answersRef.current[qid] || {}), ...patch } };
    answersRef.current = next;
    setAnswers(next);
    dirty.current.add(String(qid));
    setSaveState("dirty");
  };

  // Өөрчлөгдсөн хариултуудыг илгээнэ
  const flush = useCallback(async () => {
    if (saving.current || submitting.current || !dirty.current.size) return;
    const ids = [...dirty.current];
    dirty.current = new Set();
    saving.current = true;
    setSaveState("saving");
    try {
      const r = await req("put", `/student/exams/${id}/answers`, { answers: ids.map((qid) => ({ questionId: Number(qid), ...answersRef.current[qid] })) });
      if (r.now) offset.current = new Date(r.now).getTime() - Date.now();
      if (r.expired) { await load(); return; }
      setSaveState(dirty.current.size ? "dirty" : "saved");
    } catch (e) {
      ids.forEach((qid) => dirty.current.add(qid));
      setSaveState("error");
      if (e?.response?.status === 400) load(); // аль хэдийн илгээсэн г.м.
    } finally {
      saving.current = false;
    }
  }, [id, load]);

  const submit = useCallback(async () => {
    if (submitting.current) return;
    submitting.current = true;
    setBusy(true);
    try {
      const all = Object.entries(answersRef.current).map(([qid, a]) => ({ questionId: Number(qid), ...a }));
      const d = await req("post", `/student/exams/${id}/submit`, { answers: all });
      dirty.current = new Set();
      setSaveState("saved");
      apply(d);
      window.scrollTo(0, 0);
    } catch (e) {
      await load();
    } finally {
      submitting.current = false;
      setBusy(false);
    }
  }, [id, apply, load]);

  // Автомат хадгалалт, дэлгэц нуугдахад хадгалах, хадгалаагүй үед гарахад сануулах
  useEffect(() => {
    if (!inProgress) return undefined;
    const t = setInterval(flush, AUTOSAVE_MS);
    const vis = () => { if (document.visibilityState === "hidden") flush(); };
    const unload = (e) => { if (dirty.current.size) { e.preventDefault(); e.returnValue = ""; } };
    document.addEventListener("visibilitychange", vis);
    window.addEventListener("beforeunload", unload);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", vis); window.removeEventListener("beforeunload", unload); };
  }, [inProgress, flush]);

  // Хугацаа тоолуур; дуусвал автоматаар илгээнэ
  const deadline = inProgress && data.attempt.deadline ? new Date(data.attempt.deadline).getTime() : null;
  const remaining = deadline ? (deadline - (Date.now() + offset.current)) / 1000 : null;
  useEffect(() => {
    if (!deadline) return undefined;
    const t = setInterval(() => {
      setTick((x) => x + 1);
      if (deadline - (Date.now() + offset.current) <= 0) { clearInterval(t); submit(); }
    }, 1000);
    return () => clearInterval(t);
  }, [deadline, submit]);

  const start = () => {
    const e = data.exam;
    Modal.confirm({
      title: "Тест эхлүүлэх үү?",
      content: `${e.timeLimitMin ? `Эхэлмэгц ${e.timeLimitMin} минут тоологдож эхэлнэ. Зогсоох боломжгүй.` : "Тестийг нэг л удаа өгнө."} Тест бүтэн дэлгэцээр нээгдэнэ — дуустал гарах, өөр цонх руу шилжихийг хориглоно.`,
      okText: "Эхлэх", cancelText: "Болих",
      // Бүтэн дэлгэцийг товч дарсан агшинд (хөтөч хэрэглэгчийн үйлдэл шаарддаг)
      onOk: () => { if (fsSupported()) enterFs(); return req("post", `/student/exams/${id}/start`).then((d) => { setIdx(0); apply(d); }).catch(() => load()); },
    });
  };
  const confirmSubmit = () => {
    const left = questions.filter((q) => !isAnswered(answers[q.id])).length;
    Modal.confirm({
      title: "Тестээ илгээх үү?",
      content: left ? `${left} асуултад хариулаагүй байна. Илгээсний дараа засах боломжгүй.` : "Илгээсний дараа засах боломжгүй.",
      okText: "Илгээх", cancelText: "Буцах",
      onOk: submit,
    });
  };

  if (error) return <div className="pt-10 text-center text-gray-500 text-sm">{error}. <Link to="/exams" className="text-primary font-semibold">Буцах</Link></div>;
  if (!data) return <div className="py-16 flex justify-center"><Spin /></div>;
  const e = data.exam;

  const header = (
    <div>
      <Link to="/exams" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-primary"><FiArrowLeft /> Шалгалт</Link>
      <div className="text-xs font-semibold text-primary mt-2">{e.course?.name}</div>
      <h1 className="ptitle mt-0.5">{e.name}</h1>
    </div>
  );

  // Илгээсэн — үр дүн
  if (data.attempt && !inProgress) {
    return <div className="pt-4 md:pt-6 pb-6 max-w-3xl mx-auto flex flex-col gap-4">{header}<ResultView exam={e} attempt={data.attempt} result={data.result} /></div>;
  }

  // Эхлээгүй — танилцуулга
  if (!data.attempt) {
    return (
      <div className="pt-4 md:pt-6 pb-6 max-w-3xl mx-auto flex flex-col gap-4">
        {header}
        <section className="pcard pcard-pad flex flex-col gap-3">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
            <div><div className="text-lg font-bold">{e.questionCount}</div><div className="text-xs text-gray-500">асуулт</div></div>
            <div><div className="text-lg font-bold">{e.totalPoints}</div><div className="text-xs text-gray-500">оноо</div></div>
            <div><div className="text-lg font-bold">{e.timeLimitMin ? `${e.timeLimitMin} мин` : "—"}</div><div className="text-xs text-gray-500">хугацаа</div></div>
            <div><div className="text-lg font-bold">{e.closesAt ? fmtWhen(e.closesAt) : "—"}</div><div className="text-xs text-gray-500">хаагдах</div></div>
          </div>
          {e.instructions && <div className="text-sm text-gray-700 whitespace-pre-wrap border-t border-gray-100 pt-3">{e.instructions}</div>}
          <ul className="text-xs text-gray-500 list-disc pl-5 m-0">
            <li>Тестийг нэг л удаа өгнө. Хариулт тань хэдэн секунд тутам автоматаар хадгалагдана.</li>
            {e.timeLimitMin && <li>Эхэлмэгц хугацаа тоологдоно; дуусвал тест автоматаар илгээгдэнэ.</li>}
            <li>Тест бүтэн дэлгэцээр нээгдэнэ. Гарах, өөр цонх руу шилжвэл тоологдоно.</li>
          </ul>
          {e.state === "open" ? (
            <Button type="primary" size="large" onClick={start} disabled={!e.questionCount}>Тест эхлэх</Button>
          ) : e.state === "upcoming" ? (
            <div className="text-center text-sm text-blue-700 font-semibold">{fmtWhen(e.opensAt)}-д нээгдэнэ</div>
          ) : (
            <div className="text-center text-sm text-gray-500 font-semibold">Тест хаагдсан</div>
          )}
        </section>
      </div>
    );
  }

  // Тест өгч буй
  const q = questions[Math.min(idx, questions.length - 1)];
  const answeredCount = questions.filter((x) => isAnswered(answers[x.id])).length;
  const low = remaining != null && remaining < 60;
  const SAVE_TEXT = { saved: "Хадгалсан", dirty: "Хадгалаагүй", saving: "Хадгалж байна…", error: "Хадгалж чадсангүй — дахин оролдоно" };

  const topBar = (
      <div className="sticky top-0 z-20 -mx-4 px-4 py-2 bg-white/95 backdrop-blur border-b border-gray-100 flex items-center gap-3" style={{ paddingTop: "calc(8px + var(--safe-top, 0px))" }}>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold truncate">{e.name}</div>
          <div className={`text-[11px] ${saveState === "error" ? "text-red-600" : "text-gray-400"}`}>{answeredCount}/{questions.length} хариулсан · {SAVE_TEXT[saveState]}</div>
        </div>
        {remaining != null && (
          <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-bold tabular-nums ${low ? "bg-red-50 text-red-700" : "bg-primary/10 text-primary"}`} aria-live={low ? "polite" : "off"}>
            <FiClock /> {fmtClock(remaining)}
          </span>
        )}
        <Button type="primary" onClick={confirmSubmit} loading={busy}>Илгээх</Button>
      </div>
  );
  // Тест явагдаж буй үед порталын цэсийг нууж бүх дэлгэцийг эзэлнэ
  const shell = (children, wide) => (
    <div className="fixed inset-0 z-[900] bg-gray-50 overflow-auto">
      {lock.locked && <LockScreen leaves={lock.leaves} onResume={lock.resume} />}
      <div className={`px-4 pb-6 mx-auto flex flex-col gap-3 ${wide ? "max-w-[1400px] md:h-full" : "max-w-3xl"}`}>{topBar}{children}</div>
    </div>
  );

  if (data.sheet) {
    return shell(
      <div className="flex flex-col md:flex-row gap-4 md:flex-1 md:min-h-0">
        <div className="md:flex-1 md:min-h-0"><FileViewer examId={id} files={data.files} /></div>
        <aside className="md:w-[420px] shrink-0 md:overflow-auto rounded-xl border border-gray-200 bg-white p-4 flex flex-col gap-3">
          <div className="text-sm font-bold text-gray-900">Хариултын хуудас <span className="font-normal text-gray-500">· {answeredCount}/{questions.length}</span></div>
          <AnswerSheet questions={questions} answers={answers} examId={id} onAnswer={(qid, p) => setAnswer(qid, p)} />
          <Button type="primary" size="large" onClick={confirmSubmit} loading={busy}>Илгээх</Button>
        </aside>
      </div>, true);
  }

  return shell(
    <>
      <nav aria-label="Асуултууд" className="flex flex-wrap gap-1.5">
        {questions.map((x, i) => {
          const on = i === idx;
          const done = isAnswered(answers[x.id]);
          return (
            <button key={x.id} type="button" onClick={() => setIdx(i)} aria-current={on ? "step" : undefined} aria-label={`${i + 1}-р асуулт${done ? " (хариулсан)" : ""}`}
              className={`h-9 w-9 rounded-lg text-sm font-semibold border ${on ? "border-primary ring-2 ring-primary/30" : "border-gray-200"} ${done ? "bg-primary text-white" : "bg-white text-gray-700"}`}>
              {i + 1}
            </button>
          );
        })}
      </nav>

      {q && (
        <section className="pcard pcard-pad flex flex-col gap-3">
          <div className="flex items-center justify-between text-xs text-gray-500">
            <span>Асуулт {idx + 1} / {questions.length} · {TYPE_HINT[q.type]}</span>
            <span className="font-semibold">{q.points} оноо</span>
          </div>
          <div className="text-[15px] md:text-base text-gray-900 whitespace-pre-wrap leading-relaxed">{q.text}</div>
          {q.imageUrl && <img src={q.imageUrl} alt="" className="max-h-72 rounded-lg border border-gray-100 self-start" />}
          <AnswerInput q={q} examId={id} value={answers[q.id]} onChange={(p) => setAnswer(q.id, p)} />
        </section>
      )}

      <div className="flex justify-between gap-2">
        <Button size="large" disabled={idx === 0} onClick={() => { flush(); setIdx(idx - 1); }}>Өмнөх</Button>
        {idx < questions.length - 1
          ? <Button size="large" type="primary" ghost onClick={() => { flush(); setIdx(idx + 1); }}>Дараах</Button>
          : <Button size="large" type="primary" onClick={confirmSubmit} loading={busy}>Илгээх</Button>}
      </div>
    </>);
}
